import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import {useEffect, useState} from "react";
import CustomTable from "../customTable/CustomTable";
import PaymentTransactionInfo from "./PaymentTransactionInfo";
import {Pagination} from "@material-ui/lab";
import searchIcon from "../../assets/images/search-normal.svg";
import {convertCurrencyFormat, convertToBirthDate, convertToTime} from "../../utils/numberConvertor";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {PaymentTransactionService} from "./PaymentTransactionService";
import moment from "jalali-moment";
import * as React from "react";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {useLocation} from "react-router-dom";
import DefaultDialogPage, {DialogSize} from "../defaultDialogPage/DefaultDialogPage";
import calender from "../../assets/images/calender-1.svg";
import {css} from "@emotion/css";

let selectedItemId = -1
const PaymentTransaction = () => {

    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new PaymentTransactionService(fundID, token, snackbar, loading)


    const [filterTextFullName, setFilterTextFullName] = useState("");
    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");
    const [filterTransactionStatus, setFilterTransactionStatus] = useState(-1);

    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);

    const [paymentTransactionList, setPaymentTransactionList] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    const [summationOfAmount, setSummationOfAmount] = useState("");

    const handleClickOpen = () => {
        setOpenModal(true)
    }

    const handleClose = () => {
        setOpenModal(false)
        selectedItemId = -1
    }

    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        setOpenModal(true);
    }

    const handleChange = (event, value) => {
        page = value - 1
        getPaymentListFromServer()
    };

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getPaymentListFromServer()
        }
    }, [])

    function getPaymentListFromServer(
        searchFilter = filterTextFullName,
        startDate = filterStartDate,
        endDate = filterEndDate,
        status = filterTransactionStatus,
        searchType = searchSelectedType
    ) {
        loading(setLoadingStateDispatch(true))

        service.getPaymentsListData(
            fundID,
            searchType === SearchType.fullName ? searchFilter : "",
            searchType === SearchType.groupName ? searchFilter : "",
            searchType === SearchType.groupCode ? searchFilter : "",
            startDate,
            endDate,
            status,
            page
        ).then(response => {
            setPaymentData(response)
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت لیست تراکنش هـا!", snackbar, loading)
        })
    }

    function setPaymentData(paymentsData) {
        setItemCount(paymentsData.numberOfItems)
        setPageCount(paymentsData.totalPage)

        setPaymentTransactionList([])

        setSummationOfAmount(paymentsData.summationOfAmount)

        paymentsData.data.map((item, index) => {
            setPaymentTransactionList(prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 15) + index + 1,
                    item.payerFirstName,
                    item.payerLastName,
                    item.payerNationalCode,
                    item.createdAtDate,
                    item.createdAtPersianTime,
                    item.status,
                    item.serial,
                    item.gatewaySerial,
                    convertCurrencyFormat(item.amount),
                    item.paymentGatewayTitle,
                )
            ])
        })
    }

    function prepareGroupsJsonList(
        id, number, payerFirstName, payerLastName, payerNationalCode,
        createdAtDate, createdAtPersianTime, status, serial,
        gatewaySerial, amount,paymentGatewayTitle) {

        return {
            id: id,
            number: number,
            amount: amount,
            fullName: `${payerFirstName} ${payerLastName}`,
            nationalCode: payerNationalCode,
            date: `${convertToTime(createdAtPersianTime)} ${createdAtDate ? moment(createdAtDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : ""}`,
            status: status === "SUCCESS" ?
                <span className={`${css`white-space: nowrap`} bg_active_state`}>پرداخت شده</span> :
                status === TransactionStatus.UN_SUCCESS.id ?
                    <span className={`bg_deActive_state ${css`white-space: nowrap`}`}>ناموفق</span> :
                    <span className={`bg_warning_state ${css`white-space: nowrap`}`}>در انتظار پرداخت</span>,
            zarinpalPaymentCode: gatewaySerial,
            gateway:paymentGatewayTitle?paymentGatewayTitle:"-"
        }
    }

    const routePath = useLocation();
    const onTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        onTop()
    }, [routePath]);

    const [filterDialogOpenState, setFilterDialogOpenState] = useState(false);

    const [searchSelectedType, setSearchSelectedType] = useState("owner-full-name");

    return (
        <>
            {
                <PaymentTransactionInfo
                    openModal={openModal}
                    handleClose={handleClose}
                    selectedItemId={selectedItemId}
                />
            }

            {
                <DefaultDialogPage
                    onClose={_ => {
                        setFilterDialogOpenState(false)
                    }}
                    open={filterDialogOpenState}
                    pageTitle={"فیلتر ها"}
                    dialogSize={DialogSize.WRAP_CONTENT}
                >
                    <section
                        style={{display: "grid", gridTemplateColumns: "1fr", gap: "16px", padding: "0 16px 16px 16px"}}>

                        <TextField
                            value={convertToBirthDate(filterStartDate)}
                            onChange={e => {
                                const _date = convertToBirthDate(e.target.value)

                                if (_date.length === 10 || filterStartDate.length === 10) {
                                    getPaymentListFromServer(filterTextFullName, _date)
                                }

                                setFilterStartDate(_date)
                            }}
                            className='w-100'
                            variant="outlined" label="فیلتر تاریخ شروع"
                        />

                        <TextField
                            value={convertToBirthDate(filterEndDate)}
                            onChange={e => {
                                const _date = convertToBirthDate(e.target.value)

                                if (_date.length === 10 || filterEndDate.length === 10) {
                                    getPaymentListFromServer(filterTextFullName, filterStartDate, _date)
                                }

                                setFilterEndDate(_date)
                            }}
                            className='w-100'
                            variant="outlined" label="فیلتر تاریخ پایان"
                        />


                        <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="filled-age-native-simple">وضعیت تراکنش</InputLabel>
                            <Select label="وضعیت تراکنش"
                                    value={filterTransactionStatus}
                                    onChange={e => {
                                        getPaymentListFromServer(filterTextFullName, filterStartDate, filterEndDate, e.target.value)
                                        setFilterTransactionStatus(e.target.value)
                                    }}>
                                <option className="p-2" value={-1}>همه</option>
                                {TransactionStatusList.map((item, index) => {
                                    return <option key={index} className="p-2"
                                                   value={item.id}>{item.title}</option>
                                })}
                            </Select>
                        </FormControl>

                    </section>

                </DefaultDialogPage>
            }


            <section className={'pageContainer'} style={{overflowY: 'hidden'}}>
                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'start'}}>
                        <Typography variant={"h5"}>
                            سابقه تراکنشات درگاه بانکی
                        </Typography>
                        {itemCount >= 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {`${itemCount} تراکنش`}
                            </Typography> :
                            ''}
                    </section>
                </Box>
                <Box className="w-100" sm={12}>
                    <Grid className="d-flex flex-row flex-wrap flex-grow-1 w-100" sm={12}>
                        <Grid sm={12} md={8} lg={8} xl={8} className='modalTextFieldContainer'>
                            <TextField
                                value={filterTextFullName}
                                onChange={e => {
                                    const _name = e.target.value
                                    setFilterTextFullName(_name)
                                    getPaymentListFromServer(_name)
                                }}
                                className='w-100'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={searchIcon} alt=""/>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined" label="جستجو بر اساس نام"
                                placeholder="عبارت مورد نظر را وارد نمایید"/>
                        </Grid>

                        <Grid xs={12} sm={6} md={4} lg={4} xl={4}
                              className="d-flex flex-row flex-nowrap alignItemsCenter">
                            <FormControl variant="outlined" className="w-100" style={{flexGrow: "1"}}>
                                <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                                <Select value={searchSelectedType} onChange={e => {
                                    setSearchSelectedType(e.target.value)
                                    getPaymentListFromServer(
                                        filterTextFullName,
                                        filterStartDate,
                                        filterEndDate,
                                        filterTransactionStatus,
                                        e.target.value
                                    )
                                }}
                                        label="جستجو بر اساس">
                                    <option value={SearchType.fullName}>نام و نام خانوادگی</option>
                                    <option value={SearchType.groupName}>نام گروه</option>
                                    <option value={SearchType.groupCode}>کد گروه</option>

                                </Select>
                            </FormControl>

                            <button className="btn-date"
                                    onClick={_ => setFilterDialogOpenState(true)}>
                                <img src={calender} style={{height: "56px"}} alt=""/>
                            </button>

                        </Grid>

                    </Grid>

                </Box>
                <CustomTable
                    header={columns}
                    data={paymentTransactionList}
                    rowClicked={showEventsContent}
                    summation={summationOfAmount}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>

        </>

    )
}
export default PaymentTransaction;

const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right'
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right'
    },
    {
        id: 'date',
        label: 'تاریخ',
        align: 'right'
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'gateway',
        label: 'درگاه پرداخت',
        align: 'right',
    },
    {
        id: 'status',
        label: 'وضعیت',
        align: 'right'
    },
    {
        id: 'zarinpalPaymentCode',
        label: 'شناسه پرداخت زرین پال',
        align: 'right'
    }
]


const TransactionStatus = {
    "SUCCESS": {
        id: "SUCCESS",
        title: "موفق"
    }, "UN_SUCCESS": {
        id: "UN_SUCCESS",
        title: "ناموفق"
    }, "AWAITING_FOR_PAYMENT": {
        id: "AWAITING_FOR_PAYMENT",
        title: "در انتظار پرداخت"
    },
}

const TransactionStatusList = [TransactionStatus.SUCCESS, TransactionStatus.UN_SUCCESS, TransactionStatus.AWAITING_FOR_PAYMENT];


const SearchType = {
    fullName: "owner-full-name",
    groupName: "group-name",
    groupCode: "group-code"
}
